
import React, { useState } from 'react';
import ContentCreationSystem, { ContentType } from '../ContentCreationSystem';
import { Label } from 'recharts';

interface CreateContentDropdownProps {
  selectedModule: string;
  onContentCreated: () => void;
  modules: any[],
  subjectId: string,
}

const CreateContentDropdown: React.FC<CreateContentDropdownProps> = ({ 
  selectedModule, 
  onContentCreated ,
  modules,
  subjectId
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeModal, setActiveModal] = useState<ContentType | null>(null);

  const contentTypes = [
    { id: 'assignment', label: 'Assignment', icon: '📝' },
    { id: 'quiz', label: 'Quiz', icon: '📋' },
    { id: 'glossary', label: 'Glossary', icon: '📖' },
    { id: 'material', label: 'Material', icon: '📁' },
    { id: 'announcement', label: 'Announcement', icon: '📢' },
    { id: 'demoAssignment', label: 'DemoAssignment', icon: '📝'},
    { id: 'co/po', label: 'co/po', icon: '🏆'}

  ];

  const handleContentTypeSelect = (contentType: string) => {
    console.log(`Opening ${contentType} modal for module ${selectedModule}`);
    setIsOpen(false);
    setActiveModal(contentType as ContentType);
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  const handleContentCreated = (type: ContentType, data: any) => {
    console.log(`Content created for module ${selectedModule}:`, { type, data });
    onContentCreated();
    setActiveModal(null);
  };

  return (
    <>
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
        >
          + Create / Add
          <svg className={`ml-2 w-4 h-4 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg z-50">
            <div className="py-2">
              <div className="px-4 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                Create New:
              </div>
              {contentTypes.map((type) => (
                <button
                  key={type.id}
                  onClick={() => handleContentTypeSelect(type.id)}
                  className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 transition-colors duration-200"
                >
                  <span className="text-lg">{type.icon}</span>
                  <span className="font-medium">{type.label}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Backdrop */}
        {isOpen && (
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
        )}
      </div>

      {/* Content Creation Modal System */}
      <ContentCreationSystem
        activeModal={activeModal}
         modules={modules}
         subjectId={subjectId}
        onCloseModal={handleCloseModal}
        onContentCreated={handleContentCreated}
      />
    </>
  );
};

export default CreateContentDropdown;
